import Box from '@mui/material/Box';
import { radius } from '@/shared/theme';
import iconUrl from './fair-doctors-logo.png';
import wordmarkUrl from './fair-doctors-wordmark.svg';

interface LogoProps {
  /** `plaque`: white badge for dark surfaces (sidebar); `mini`: square badge; `plain`: image only. */
  variant?: 'plaque' | 'mini' | 'plain';
  height?: number;
}

/** Fair Doctors wordmark (tooth mark + "Fair Doctors"), from fair-doctors.de's own brand asset. */
export function Logo({ variant = 'plain', height = 21 }: LogoProps) {
  const img = (
    <Box
      component="img"
      src={wordmarkUrl}
      alt="Fair Doctors"
      sx={{ display: 'block', height, width: 'auto' }}
    />
  );

  if (variant === 'plain') return img;

  const badge = { background: '#FFFFFF' };

  if (variant === 'mini') {
    // Collapsed sidebar: the wordmark is too wide for a square badge, so this uses the icon mark.
    return (
      <Box
        sx={{
          ...badge,
          width: 46,
          height: 46,
          flex: 'none',
          borderRadius: radius.control,
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          '& img': { height: 28 },
        }}
      >
        <Box component="img" src={iconUrl} alt="Fair Doctors" sx={{ display: 'block' }} />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        ...badge,
        display: 'inline-flex',
        alignItems: 'center',
        borderRadius: radius.sm,
        px: 1.5,
        py: '7px',
      }}
    >
      {img}
    </Box>
  );
}
